import { lazy } from 'react';
import { CRoutes } from 'src/routes';
import { getLinkRoute } from './helpers';

const SubmissionProgressPage = lazy(() => import('src/pages/SubmissionProgress'));

const ROUTE_SUBMISSION_PROGRESS = '/campaigns/submissionprogress/:permanentUrl?';

export const getSubmissionProgressRoute = (permanentUrl: string) =>
  getLinkRoute(ROUTE_SUBMISSION_PROGRESS, { permanentUrl });

export const submissionProgressRoutes: CRoutes = [
  {
    path: ROUTE_SUBMISSION_PROGRESS,
    Component: SubmissionProgressPage,
    exact: true,
    showFooter: false,
  },
];
